import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchAgentServiceTimePerService from "../../../components/branches/reports/daily/BranchAgentServiceTimePerService";
import {
  AGENT_SERVICE_TIME_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const DailyBranchAgentServiceTimePerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={AGENT_SERVICE_TIME_COLUMN_DEFINITIONS}
    descriptionKey="AgentServiceSessionTime"
    normalizeData={asArray}
    title={`${reportIndex}. Agent Service Time Per Service`}
  >
    {({ data, renderConfig }) => (
      <BranchAgentServiceTimePerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchAgentServiceTimePerService;
